import { ITypedReduxAction } from '../../types/redux/actionType';
import { TUser } from '../../types/user';

export enum EGetUserStatus {
  SetUserData = 'user/succeed',
}

export type IGetUserData = ITypedReduxAction<EGetUserStatus.SetUserData, TUser>;

export type TUserActions = IGetUserData;
